


























import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _sampleSize from 'lodash/sampleSize'
import _filter from 'lodash/filter'
import _reject from 'lodash/reject'

import BaseLink from '@/components/common/BaseLink.vue'
import BaseImageTeaser from '@/components/common/BaseImageTeaser.vue'
import IntroductionOverlay from '@/components/overlays/IntroductionOverlay.vue'
import SourceDetailOverlay from '@/components/overlays/SourceDetailOverlay.vue'

import { Meta } from '@/service/utils'
import { IAssociation } from '@/models'

@Component( {
    components: {
        'oe-link': BaseLink,
        'oe-base-image-teaser': BaseImageTeaser,
        'oe-introduction-overlay': IntroductionOverlay,
        'oe-source-detail-overlay': SourceDetailOverlay
    },
    computed: mapGetters( {
        sawIntro: 'globalModule/sawIntro',
        totalAssociations: 'associationsModule/totalAssociations',
        totalImages: 'imagesModule/totalImages',
        totalUsers: 'usersModule/totalUsers',
        associations: 'associationsModule/associations',
    } )
} )
export default class HomeView extends Vue {
    $refs!: {
        introductionOverlay: IntroductionOverlay;
        sourceDetailOverlay: SourceDetailOverlay;
    }
    activeSlide = 0
    sawIntro!: boolean
    associations!: any
    images!: any

    @Meta
    metaConfig() {
        return {
            title: this.$t( 'HOME_VIEW.META.TITLE' ),
            meta: [
                {
                    name: 'description',
                    content: this.$t( 'HOME_VIEW.META.DESCRIPTION' )
                }
            ]
        }
    }

    get teaserItems() {
        const preselectedItems = _filter( this.associations, ( association ) => association.created_by && association.language === this.$i18n.locale )

        return _sampleSize( preselectedItems, 3 )
    }

    get associationsByLanguage() {
        return ( value: Array<IAssociation>, filter: { [key: string]: string } ) => _filter( value, filter )
    }

    startExplorer () {
        if ( this.sawIntro ) {
            this.$router.push( `/${this.$i18n.locale}/explorer` )
        } else {
            this.$refs.introductionOverlay.showOverlay()
        }
    }

    showSourceDetailOverlay( imageId: string ) {
        this.$store.commit( 'imagesModule/setCurrentImage', imageId )
        this.$refs.sourceDetailOverlay.showOverlay()
    }

    mounted() {
        this.$on( 'slideChange', ( value: number ) => this.activeSlide = value )
        this.$on( 'imageSelected', ( imageId: string )  => this.showSourceDetailOverlay( imageId ) )
    }
}
